import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import config from '@/config'

const RouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}
const RouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return RouterReplace.call(this, to).catch(err => err)
}

const title = config.title

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: title + '-首页'
          }
        },
        {
          path: '/video',
          name: 'video',
          component: resolve => require(['@/view/video/index.vue'], resolve),
          meta: {
            title: title + '-视频中心'
          }
        },
        {
          path: '/EDWinXP',
          name: 'EDWinXP',
          component: resolve => require(['@/view/Product_EDWinXPIntro'], resolve),
          meta: {
            title: title + '-EDWinXP特点'
          }
        },
        {
          path: '/more-info-page',
          name: 'more-info-page',
          component: resolve => require(['@/view/ReadMore'], resolve),
          meta: {
            title: title + '-EDWinXP特点'
          }
        },
        {
          path: '/about-us',
          name: 'about-us',
          component: resolve => require(['@/view/AboutUs'], resolve),
          meta: {
            title: title + '-关于我们'
          }
        },
        {
          path: '/alone-page/:id',
          name: 'alone-page',
          component: resolve => require(['@/view/alonePage'], resolve),
          meta: {
            title: title + '-页面管理'
          }
        },
        {
          path: '/product',
          name: 'product',
          component:  () => import('@/view/EmptyComponent'),
          redirect: '/product/summary',  // 添加重定向
          meta: {
            title: title + '-软件产品'
          },
          children: [
            {
              path: '/product/EDWinXP',
              name: 'EDWinXP',
              component:  () => import('@/view/EmptyComponent'),
             redirect: '/product/EDWinXPIntro',  // 添加重定向
              // component: () => import('@/view/Product_EDWinXPIntro'),
              meta: {
                title: '产品-EDWinXP'
              },
              children: [
                {
                  path: '/product/EDWinXP/EDWinXPIntro',
                  name: 'EDWinXP',
                  component:  () => import('@/view/EmptyComponent'),
                  redirect: '/product/EDWinXPIntro',  // 确保有对应的视图组件
                  meta: {
                    title: '产品-EDWinXP简介'
                  },
                  children: [  // 添加子路由
                  {
                      path: '/product/EDWinXP/EDWinXPIntro/schematic',
                      name: 'EDWinXP-sublink1',
                      component:  () => import('@/view/EmptyComponent'),
                      redirect: '/product/schematic',  // 确保有对应的视图组件
                      meta: {
                        title: 'EDWinXP-原理图编辑器'
                      },
                      children: [
                        {
                          path: "/product/EDWinXP/EDWinXPIntro/schematic/loadingComponents",
                          name: "EDWinXP-加载组件",
                          component: () => import('@/view/Schematic_loadComponent'),  // 确保有对应的视图组件
                        },
                        {
                          path: "/product/EDWinXP/EDWinXPIntro/schematic/establishConnection",
                          name: "EDWinXP-建立连接",
                          component: () => import('@/view/Schematic_establishConnection'),  // 确保有对应的视图组件
                        },
                        {
                          path: "/product/EDWinXP/EDWinXPIntro/schematic/autoPlace",
                          name: "EDWinXP-自动部署",
                          component: () => import('@/view/Schematic_autoPlace'),  // 确保有对应的视图组件
                        },
                      ]
                      },
                      {
                        path: '/product/EDWinXP/EDWinXPIntro/layout',
                        name: 'EDWinXP-布线编辑器',
                        component:  () => import('@/view/EmptyComponent'),
                        redirect: '/product/layout',  // 确保有对应的视图组件
                        meta: {
                          title: 'EDWinXP-布线编辑器'
                        },
                        children: [
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/layout/buryVias",
                          name: "布线编辑器-埋孔",
                          component: () => import('@/view/Layout_buryVias'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/layout/3DViewer",
                          name: "布线编辑器-3D视图",
                          component: () => import('@/view/Layout_3DViewer'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/layout/autoRouter",
                          name: "布线编辑器-3D视图",
                          component: () => import('@/view/Layout_AutoRouter'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/layout/Characteristics-Impedance",
                          name: "布线编辑器-3D视图",
                          component: () => import('@/view/Layout_Characteristics-Impedance'),  // 确保有对应的视图组件
                          },
                        ]
                      },

                      {
                        path: '/product/EDWinXP/EDWinXPIntro/fabrication',
                        name: 'EDWinXP-制造管理器',
                        component:  () => import('@/view/EmptyComponent'),
                        redirect: '/product/fabrication',  // 确保有对应的视图组件
                        meta: {
                          title: 'EDWinXP-制造管理器'
                        },
                        children: [
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/fabrication/gerber",
                          name: "制造管理器-生成Gerber输出",
                          component: () => import('@/view/Fabrication_Gerber'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/fabrication/NC-drill",
                          name: "制造管理器-数控钻孔机",
                          component: () => import('@/view/Fabrication_NC-Drill'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/fabrication/PCBAssembly_BareBoard",
                          name: "制造管理器-PCB组装输出 & 裸板测试",
                          component: () => import('@/view/Fabrication_PCBAssembly-Bareboard'),  // 确保有对应的视图组件
                          },
                          {
                            path: "/product/EDWinXP/EDWinXPIntro/fabrication/Export",
                          name: "制造管理器-导出",
                          component: () => import('@/view/Fabrication_Exports'),  // 确保有对应的视图组件
                          },
                        ]
                      },

                      {
                        path: "/product/EDWinXP/EDWinXPIntro/Simulation",
                        name: "模拟器",
                        component: () => import('@/view/EDWinXPIntro_Simulation'),  // 确保有对应的视图组件
                      },
                      {
                        path: "/product/EDWinXP/EDWinXPIntro/General",
                        name: "常规特性",
                        component: () => import('@/view/EDWinXPIntro_General'),  // 确保有对应的视图组件
                      },

                    ]
                },
              ]
            },
            // {
            //   path: '/product/EDWinXP2.10',
            //   name: 'EDWinXP',
            //   component:  () => import('@/view/EmptyComponent'),
            //   redirect: '/product/EDWinXPIntro',  // 添加重定向
            //   meta: {
            //     title: '产品-EDWinXP2.10'
            //   }
            // },
            {
              path: '/product/summary',
              name: 'EDWinXP',
              component:  () => import('@/view/Product_Summary'),
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },


            {
              path: '/product/fabrication',
              name: 'EDWinXP',
              component:  () => import('@/view/EDWinXPIntro_fabrication'),
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },
            {
              path: '/product/layout',
              name: 'EDWinXP',
              component:  () => import('@/view/EDWinXPIntro_layout'),
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },
            {
              path: '/product/schematic',
              name: 'EDWinXP',
              component:  () => import('@/view/EDWinXPIntro_schematic'),
              // redirect: '/product/EDWinXPIntro',
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },
            {
              path: '/product/EDWinXPIntro',
              name: 'EDWinXP',
              component:  () => import('@/view/Product_EDWinXPIntro'),
              // redirect: '/product/EDWinXPIntro',
              meta: {
                title: '产品-EDWinXP基本特性'
              }
            },
            {
              path: '/product/EDWin3/Docs',
              name: 'EDWinXP',
              component: () => import('@/view/docs/Investigate'),
              // redirect: '/product/EDWinXPIntro',
              children: [{
                path: '/docs/ZhiJi',
                name: 'ZhiJi',
                component: () => import('@/view/docs/ZhiJi'),
              },
              {
                path: '/docs/ZhiFa',
                name: 'ZhiFa',
                component: () => import('@/view/docs/ZhiFa'),
              },
              {
                path: '/docs/DangJi',
                name: 'DangJi',
                component: () => import('@/view/docs/DangJi'),
              }
              ],
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },
            {
              path: '/product/EDWin3',
              name: 'EDWin3',
              component: () => import('@/view/Product_EDWin3'),
              meta: {
                title: '产品-EDWin3'
              },
            },
            {
              path: '/product/EDWinXP2.10',
              name: 'EDWinXP',
              component:  () => import('@/view/EDWinXP_NewFeature2.10'),
              // redirect: '/product/EDWinXPIntro',
              meta: {
                title: '产品-EDWinXP2.10'
              }
            },
            {
              path: '/product/EDWin2.11',
              name: 'EDWin2.11',
              component: () => import('@/view/Product_EDWin2.11'),
              meta: {
                title: '产品-EDWin2.11'
              }
            },
            {
              path: '/product/EDWin3',
              name: 'EDWin3',
              component:  () => import('@/view/EmptyComponent'),
              redirect: '/product/EDWin3',  // 添加重定向
              meta: {
                title: '产品-EDWin3'
              },
              children:[
                {
                  path: '/product/EDWin3/Docs',
                  name: 'EDWin3Doc',
                  component:  () => import('@/view/EmptyComponent'),
             redirect: '/product/EDWin3/Docs',  // 添加重定向

                }
              ]
            },
            {
              path: '/product/DocOne&EDComX',
              name: 'EDComX',
              component: () => import('@/view/EDWinXP_DocOne&EDComX'),
              meta: {
                title: '产品-EDComX'
              }
            },
            {
              path: '/product/Enterprise_License_Manager',
              name: 'Enterprise_License_Manager',
              component: () => import('@/view/EDWinXP_LicenseManager'),
              meta: {
                title: '产品-Enterprise_License_Manager'
              }
            },
            {
              path: '/product/EDWinNET',
              name: 'EDWinNET',
              component: () => import('@/view/Product_EDWinNET'),
              meta: {
                title: '产品-EDWinNET'
              }
            },
          ]
        },
        {
          path: '/download',
          name: 'download',
          component: () => import('@/view/Download_EDWinSeries'),
          meta: {
            title: title + '-下载'
          },
          children: [
            {
              path: '/download/EDWin_Series',
              name: 'EDWinXP_Download',
              component: () => import('@/view/Download_EDWinSeries'),
            },
            {
              path: '/download/EDWin2.11',
              name: 'EDWin2.11_Download'
            },
            {
              path: '/download/EDWin3',
              name: 'EDWin3_Download',
            }
          ],
        },
        // {
        //   path: '/download',
        //   name: 'download',
        //   component: resolve => require(['@/view/AboutUs'], resolve),
        //   meta: {
        //     title: title + '-下载'
        //   },
        //   children: [
        //     {
        //       path: '/download/EDWinXP',
        //       name: 'EDWinXP_Download',
        //       children: [
        //         {
        //           path:'/download/licenseManager',
        //           name: 'LicenseManager_Download',
        //           component: () => import('@/view/Product_AsPacker'),
        //         },
        //         {
        //           path:'/download/gettingStarted',
        //           name: 'gettingStarted_Download'
        //         },
        //         {
        //           path: '/download/DocOne',
        //           name:'DocOne_Download'
        //         },
        //         {
        //           path: '/download/EDComX',
        //           name:'EDComX_Download'
        //         },
        //         {
        //           path:'/download/Library',
        //           name: 'Library_Download'
        //         }
        //       ],
        //     },
        //     {
        //       path: '/download/EDWin2.11',
        //       name: 'EDWin2.11_Download'
        //     },
        //     {
        //       path: '/download/EDWin3',
        //       name: 'EDWin3_Download',
        //     }
        //   ],
        // },

        {
          path:'/Install_XP',
          name:'EDWinXP_InstallNotes',
          component: () => import('@/view/Install_XP'),
          meta: {
            title: title + '-安装流程'
          }
        },
        {
          path:'/onlineShop',
          name:'buy_Product',
          component: () => import('@/view/OnlineShop'),
          meta: {
            title: title + '-在线商店'
          }
        },
         {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: title + '-新闻动态'
          }
        },
        {
          path: '/newsinformationdetail',
          name: 'newsinformationdetail',
          component: resolve => require(['@/view/NewsInformationDetail'], resolve),
          meta: {
            title: title + '-新闻详情'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: title + '-公司介绍'
          }
        },
        {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: title + '-工作机会'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        },
        {
          path: '/materials',
          name: 'materials',
          component: resolve => require(['@/view/materials'], resolve),
          meta: {
            title: title + '-资料'
          }
        },
        {
          path: '/helpList',
          name: 'helpList',
          component: resolve => require(['@/view/materialsDetail'], resolve),
          meta: {
            title: title + '-资料'
          },
          children: [
            {
              path: '/helpList/:id',
              name: 'helpListDetail',
              component: () => import('@/view/materialsDetailDesc.vue'),
              meta: {
                title: '-资料'
              }
            }
          ]
        },
        {
          path: '/support',
          name: 'support',
          component: resolve => require(['@/view/support'], resolve),
          meta: {
            title: title + '-服务与支持'
          }
        },
        {
          path: '/leaveMessage',
          name: 'leaveMessage',
          component: resolve => require(['@/view/LeaveMessage'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        },{
          path: '/leaveMessage/:id',
          name: 'leaveMessage',
          component: resolve => require(['@/view/LeaveMessageDetail'], resolve),
          meta: {
            title: title + '-联系我们'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js